import { render } from "./CoverBlock.vue?vue&type=template&id=5694aa89&scoped=true"
import script from "./CoverBlock.vue?vue&type=script&lang=js"
export * from "./CoverBlock.vue?vue&type=script&lang=js"

import "./CoverBlock.vue?vue&type=style&index=0&id=5694aa89&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-5694aa89"

export default script